import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiFeesService() {
  return fetch(`clients`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
